import type { ExpressionRule } from "./types.ts";

// Rules for every profession: guarantees, superlatives and pressure tactics
// are what professional advertising rules most often prohibit.
export const COMMON_RULES: ExpressionRule[] = [
  {
    id: "guarantee",
    // 「必ず〜してください」「必ず確認」 are instructions to the reader, not promises.
    pattern: /必ず(?!しも|[^。\n]{0,24}?(?:ください|必要があります|しましょう|確認|確かめ|忘れずに))|絶対(に)?(?!的)|100[%％]|確実に|間違いなく|保証(します|いたします)/g,
    severity: "high",
    category: "成果の保証",
    message: "結果を保証する表現は、誇大・誤認を招く広告とみなされるおそれがあります",
    suggestion: "「〜が期待できます」「多くの場合〜です」など、条件や個別性を示す表現にする",
  },
  {
    id: "superlative",
    pattern: /(地域|業界|県内|市内|日本|全国)\s?(No\.?\s?1|ナンバーワン|一位|1位|一番)|日本一|最高の|最強|唯一の|最安/g,
    severity: "high",
    category: "根拠のない最上級・比較",
    message: "客観的な根拠のない最上級・比較の表現は使えません",
    suggestion: "具体的な実績（件数・期間）を事実として書くか、表現を削る",
  },
  {
    id: "free",
    pattern: /完全無料|一切費用(は|が)?かかりません/g,
    severity: "medium",
    category: "費用の表示",
    message: "条件付きで費用が発生する場合、有利誤認になるおそれがあります",
    suggestion: "「初回相談は無料（30分まで）」のように条件を明記する",
  },
  {
    id: "pressure",
    pattern: /今すぐ(申し込|ご相談|依頼)しないと|手遅れになります|損をします/g,
    severity: "medium",
    category: "不安をあおる表現",
    message: "過度に不安をあおる表現は信頼を損ないます",
    suggestion: "「早めにご相談いただくと選択肢が広がります」など前向きな表現にする",
  },
  {
    id: "vague-source",
    pattern: /(と|が)言われています|一般的に(は)?.{0,12}とされ/g,
    severity: "low",
    category: "根拠があいまい",
    message: "根拠があいまいです。一次資料（法令・公的機関の資料）を示すか、表現を改めてください",
    suggestion: "出典となる法令名・資料名を示す",
  },
];
